import React from "react";
import ReactDOM from 'react-dom';
import Link from "gatsby-link";
import Img from "gatsby-image";
import $ from 'jquery';
import { slugify } from '../components/slugify';

const BaseHref = "http://46.4.51.11:1337"
let DivSet;


let hashFilter;


const ArbeitsgebieteDetail = ({ data }) => (


  <div className="row ag-rows">


    {
      (!data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Images[0]) ?
        //  all detail images missing
        DivSet = (
          <div className="row">
      
            <div className="col-xs-12 col-md-6" style={{ backgroundImage: 'url(' + data.strapiArbeitsgebiete.Arbeitsgebiete_Image.childImageSharp.sizes.src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', minHeight: '300px' }}></div>
            <div className="col-xs-12 col-md-6 bg-white" style={{ borderLeft: '8px solid #efefef' }}>
              <h1>{data.strapiArbeitsgebiete.Title}</h1>
              <div className="row content">
                <div className="col-xs-6">
                  <div dangerouslySetInnerHTML={{ __html: data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Text }} />
                  <Link to={'/projekte#filter=' + slugify(data.strapiArbeitsgebiete.Title)}>
                    <button>Referenzen zu diesem Gebiet</button>
                  </Link>
                </div>

                <div className="col-xs-6 detail">
                  <div dangerouslySetInnerHTML={{ __html: data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_List }} />
                </div>

              </div>
            </div>
          </div>
        )


        : (

          (!data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Images[1]) ?

            // first detail image missing
            DivSet = (
              <div className="row">

                <div className="col-xs-12 col-md-3" style={{ backgroundImage: 'url(' +"/static" + data.strapiArbeitsgebiete.Arbeitsgebiete_Image.childImageSharp.sizes.src + ')', backgroundSize: 'cover', backgroundPosition: 'left center', minHeight: '300px', borderRight: '4px solid #efefef' }}></div>

                <div className="col-xs-12 col-md-3" style={{ backgroundImage: 'url(' +"/static" + data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Images[0].url + ')', backgroundSize: 'cover', backgroundPosition: '70% center', minHeight: '300px', borderLeft: '7px solid #efefef' }}></div>

                <div className="col-xs-12 col-md-6 bg-white" style={{ borderLeft: '8px solid #efefef' }}>
                  <h1>{data.strapiArbeitsgebiete.Title}</h1>
                  <div className="row content">
                    <div className="col-md-6 col-xs-12">
                      <div dangerouslySetInnerHTML={{ __html: data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Text }} />
                      <Link to={'/projekte#filter=' + slugify(data.strapiArbeitsgebiete.Title)}>
                        <button>Referenzen zu diesem Gebiet</button>
                      </Link>                  
                      </div>

                    <div className="col-xs-6 detail">
                      <div dangerouslySetInnerHTML={{ __html: data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_List }} />
                    </div>

                  </div>
                </div>
              </div>



            )

            :
            // no image missing
            DivSet = (
              <div className="row">


                <div className="col-xs-12 col-md-3" style={{ backgroundImage: 'url(' + data.strapiArbeitsgebiete.Arbeitsgebiete_Image.childImageSharp.sizes.src + ')', backgroundSize: 'cover', backgroundPosition: '60% center', minHeight: '300px' }}></div>
                
                <div className="col-xs-12 col-md-3 ag-second-col">
                  <div className="col" style={{ backgroundImage: 'url(' +"/static" + data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Images[0].url + ')', backgroundSize: 'cover', backgroundPosition: 'center center', minHeight: '300px', width: '100%', height: '50%', borderBottom: '4px solid #efefef' }}></div>
                  <div className="col" style={{ backgroundImage: 'url(' +"/static" + data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Images[1].url + ')', backgroundSize: 'cover', backgroundPosition: 'center center', minHeight: '300px', width: '100%', height: '50%', borderTop: '4px solid #efefef' }}></div>
                </div>


                <div className="col-xs-12 col-md-6 bg-white">
                  <h1>{data.strapiArbeitsgebiete.Title}</h1>
                  <div className="row content">
                    <div className="col-md-6 col-xs-12">
                      <div dangerouslySetInnerHTML={{ __html: data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_Text }} />
                      <Link to={'/projekte#filter=' + slugify(data.strapiArbeitsgebiete.Title)}>
                        <button>Referenzen zu diesem Gebiet</button>
                      </Link>
                    </div>

                    <div className="col-md-6 col-xs-12 detail">
                      <div dangerouslySetInnerHTML={{ __html: data.strapiArbeitsgebiete.Arbeitsgebiet_Detail_List }} />
                    </div>

                  </div>
                </div>
              </div>

            )
        )
    }

  </div>
);


export default ArbeitsgebieteDetail;

export const query = graphql`
 query ArbeitsgebieteDetail($id: String!) {

    strapiArbeitsgebiete(id: { eq: $id }) {
     Title
      Arbeitsgebiet_Detail_Text
      Arbeitsgebiet_Detail_List
      Arbeitsgebiete_Image{
          childImageSharp{
                    sizes {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                    }
                }
      }
      Arbeitsgebiet_Detail_Images{
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/arbeitsgebiete_detail.js